// @flow
import {selectLanguageList} from '@userstory/i18n';
import type {TDropdownOption, TDropdownLanguageCodes} from 'modules/common/types';
import type {TRootState} from 'types';

/**
 * Получить список языковых кодов
 * @param state глобальный стор
 * @return массив языковых кодов
 */
export function selectLanguageCodes(state: TRootState): TDropdownLanguageCodes[] {
    let languagesList = selectLanguageList(state).list;
    let formattedLanguagesList = [];

    Object.keys(languagesList).forEach((languageKey) => {
        const language = languagesList[languageKey];
        if (language && language.url && language.id) {
            formattedLanguagesList.push({
                code: language.url,
                id: language.id,
            });
        }
    });

    return formattedLanguagesList;
}

/**
 * Получить список языков
 * @param state глобальный стор / name, id
 * @return массив языков
 */
export function selectLanguageData(state: TRootState): TDropdownOption[] {
    let languagesList = selectLanguageList(state).list;
    let formattedLanguagesList = [];

    Object.keys(languagesList).forEach((languageKey) => {
        const language = languagesList[languageKey];
        if (language && language.name && language.id) {
            formattedLanguagesList.push({
                label: language.name,
                value: String(language.id),
            });
        }
    });

    return formattedLanguagesList;
}
